export const EXCEL_MIME_TYPES = [
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-excel',
];

export const PROJECT_NAME_MIN = 5;
export const PROJECT_NAME_MAX = 120;

export const DEFAULT_UNIT = 'шт';

export const POSITIONS_TEMPLATE_HEADERS: Record<string, string[]> = {
    name: ['Наименование товара', 'Наименование', 'Наименование продукта', 'Товар'],
    spec: [
        'Дополнительная характеристика товара',
        'Дополнительные характеристики',
        'Характеристики',
        'Описание',
    ],
    qty: ['Количество товара, планируемого к приобретению', 'Количество', 'Кол-во'],
    unit: ['Ед.измерения', 'Единица измерения', 'Ед. изм.', 'Единица'],
    region: ['Регион поиска', 'Регион', 'Город'],
    priceFrom: ['Минимальная цена за ед., руб.', 'Цена от', 'Минимальная цена'],
    priceTo: ['Максимальная цена за ед., руб.', 'Цена до', 'Максимальная цена'],
    requestPrice: [
        'Цена товара за ед.',
        'Цена товара за единицу',
        'Цена за ед.',
        'Цена за единицу',
        'Цена товара за ед., руб.',
        'Цена товара за ед. (руб.)',
    ],
    analogs: ['Аналоги', 'Поиск аналогов', 'Искать аналоги'],
    logistics: ['Логистика', 'Расчёт логистики', 'Доставка'],
};

export const TEMPLATE_ROW_NUMBER_HEADERS = ['№ п/п', '№', 'N п/п'];

export const TEMPLATE_LEGEND_VALUES = ['обязательное поле', 'обязательные поля'];